export class PlayerTimelineConversationMarkMarkerDto {
  color: string;
  text: string;
  width: number;
  position: number;
  startMillisecond: number;
  endMillisecond: number;
  channel: number;
}
